import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link, Drawer } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Scrollbar from '../../components/scrollbar';
import NavSection from '../../components/nav-section';
//
import '../../../../i18n.js';
import { getNavConfigStakeholder, navConfig, navConfigStakeholder } from './config';
import logoBlack from "../../../../images/logoBlack.png";
import abeplLogo from "../../../../images/abeplLogo.png";
import { useData } from '../../../../App';
import { getLocalStorageItem } from '../../../localStorageUtils.js';
import jwt from 'jwt-decode';
import { GET_STAKEHOLDER_BY_URN } from '../../../URLs.js';
import apiClient from '../../../../axios.js';
import { loaderService } from '../../../custom-loader/loader-service.js';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;
// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const URN = localStorage.getItem('urn')

  const isDesktop = useResponsive('up', 'lg');

  const [menuConfig, setMenuConfig] = useState([]);


  useEffect(() => {
    if (getLocalStorageItem('urn')) {
      getStakeDetails();
    }
  }, [getLocalStorageItem('urn')]);

  function getStakeDetails() {
    loaderService.showLoader();
    apiClient
      .post(GET_STAKEHOLDER_BY_URN,
        {
          "urn": getLocalStorageItem('urn')
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        const stakeholder = response.data.stakeHolder;
          if (stakeholder?.categoryName) {
              var category = (stakeholder?.categoryName == 'Grower' ? stakeholder.growerMasters[0].growerType : stakeholder?.categoryName);
              const modules = getNavConfigStakeholder(category, stakeholder?.registrationStatus);
          setMenuConfig(modules);  // <--- This is the correct shape: [ { title, path... } ]
        } else {
          setMenuConfig(navConfig); // fallback for admin or non-stakeholders
        }

        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const logo = (
    <Box
      component="img"
      src={abeplLogo} alt="logo" loading='lazy' sx={{ width: 120, height: 120 }}
    />
  );

  const renderContent = (
    <Scrollbar
      className='drawerNav'
      sx={{
        height: "auto",
        minHeight: "100%",
        '& .simplebar-content': { height: "auto", width: "100%", minHeight: "100%", display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'flex', justifyContent: 'center' }}>
        <Link to={localStorage.getItem("home_path") || pathname} component={RouterLink} sx={{ display: 'contents' }}>
          {logo}
        </Link>
      </Box>

      <NavSection data={menuConfig} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              borderRadius: '20px'
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              borderRadius: '20px'
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
